<template>
  <div id="pageTable">
    <!-- Overlay Loading cho Export Excel -->
    <v-overlay :value="isExporting" color="white" opacity="0.8">
      <div class="text-center">
        <v-progress-circular
          indeterminate
          size="64"
          color="primary"
          class="mb-4"
        ></v-progress-circular>
        <div class="title">Đang xuất file Excel...</div>
        <div class="subtitle-1 mt-2">Vui lòng chờ trong giây lát</div>
        <div class="caption mt-1 grey--text">
          <v-icon small color="grey">mdi-information</v-icon>
          Hệ thống đang xử lý hình ảnh và tạo file Excel
        </div>
      </div>
    </v-overlay>
    
    <v-container grid-list-xl fluid>
      <v-card>
        <v-layout row wrap pa-6>
          <!-- Cột 1: Thông tin khai báo -->
          <v-flex xs12 md6>
             <!-- Tên yêu cầu xuất hoá đơn (khai báo) -->
          <v-row>
            <v-col cols="12">
              <v-card outlined class="mt-4">
                <v-card-title class="pa-4">
                  <v-icon left>mdi-file-document-outline</v-icon>
                  Tên yêu cầu xuất hoá đơn (khai báo hải quan)
                </v-card-title>
                <v-card-text>
                  <!-- Combobox để tìm kiếm và chọn suggestions -->
                  <v-combobox
                    v-model="selectedProductSuggestion"
                    :items="productSuggestions"
                    :search-input.sync="productSearchInput"
                    label="Tìm kiếm gợi ý từ dữ liệu có sẵn"
                    placeholder="Nhập để tìm kiếm gợi ý..."
                    outlined
                    dense
                    clearable
                    item-text="text"
                    item-value="value"
                    @change="onSuggestionSelected"
                    :loading="searchLoading"
                    :menu-props="{ maxHeight: '200' }"
                    no-filter
                    hide-details
                  >
                    <template v-slot:selection="{ item }">
                      <span>{{ typeof item === 'object' ? item.text : item }}</span>
                    </template>
                    <template v-slot:item="{ item }">
                      <v-list-item-content>
                        <v-list-item-title>{{ item.text }}</v-list-item-title>
                      </v-list-item-content>
                    </template>
                    <template v-slot:no-data>
                      <v-list-item>
                        <v-list-item-content>
                          <v-list-item-title>
                            {{ productSearchInput && productSearchInput.length > 1 ? 'Không tìm thấy gợi ý' : 'Nhập ít nhất 2 ký tự để tìm kiếm' }}
                          </v-list-item-title>
                        </v-list-item-content>
                      </v-list-item>
                    </template>
                  </v-combobox>
                  
                  <!-- Text area để edit tự do -->
                  <v-textarea
                    v-model="currentItem.ProductInfo"
                    label="Tên yêu cầu xuất hoá đơn (tên hàng + tên khai báo hải quan)"
                    placeholder="Nhập hoặc chỉnh sửa tên hàng..."
                    outlined
                    dense
                    rows="3"
                    class="mt-3"
                  >
                    <template v-slot:append>
                      <v-tooltip bottom>
                        <template v-slot:activator="{ on, attrs }">
                          <v-btn
                            icon
                            small
                            @click="applySelectedSuggestionToProductInfo"
                            :disabled="!selectedProductSuggestion"
                            v-bind="attrs"
                            v-on="on"
                          >
                            <v-icon small color="primary">mdi-arrow-down</v-icon>
                          </v-btn>
                        </template>
                        <span>Áp dụng gợi ý đã chọn</span>
                      </v-tooltip>
                    </template>
                  </v-textarea>
                  
                  <!-- Hint text -->
                  <div class="text-caption grey--text mt-1">
                    <v-icon small color="grey">mdi-lightbulb-outline</v-icon>
                    Mẹo: Tìm kiếm gợi ý ở ô trên, sau đó nhấn nút ↓ để áp dụng hoặc nhập trực tiếp vào ô dưới
                  </div>
                </v-card-text>
              </v-card>
            </v-col>
          </v-row>
            <v-card outlined>
              <v-card-title>
                <v-icon left>mdi-file-document-outline</v-icon>
                Thông tin khai báo
              </v-card-title>
              <v-card-text>
                <!-- <v-row>
                  <v-col cols="12">
                    <v-text-field
                      v-model="currentItem.CustomsContent"
                      label="Yêu cầu khai báo"
                      class="input-group--focused"
                      outlined
                      dense
                    ></v-text-field>
                  </v-col>
                </v-row>
                
                <v-row>
                  <v-col cols="12" md="4">
                    <v-text-field
                      v-model="currentItem.CustomsPriceNote"
                      label="Thuế & giá khai báo"
                      class="input-group--focused"
                      outlined
                      dense
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" md="4">
                    <v-text-field
                      v-model="currentItem.CustomsUnit"
                      label="Đơn vị khai báo"
                      class="input-group--focused"
                      outlined
                      dense
                    ></v-text-field>
                  </v-col>
                </v-row> -->
                <!-- Khách hàng -->
                <v-row>
                  <v-col cols="12" md="12">
                    <v-autocomplete 
                      outlined 
                      dense 
                      label="Khách hàng" 
                      v-model="currentItem.UID" 
                      :items="filteredCustomers" 
                      item-text="Username" 
                      item-value="ID"
                      :search-input.sync="customerSearchInput"
                      clearable
                      :menu-props="{ maxHeight: '200' }"
                    >
                      <template v-slot:selection="{ item }">
                        <span>{{ item.Username }} - {{ item.FullName || 'N/A' }}</span>
                      </template>
                      <template v-slot:item="{ item }">
                        <v-list-item-content>
                          <v-list-item-title>{{ item.Username }}</v-list-item-title>
                          <v-list-item-subtitle>{{ item.FullName || 'N/A' }} | {{ item.PhoneNumber || 'N/A' }}</v-list-item-subtitle>
                        </v-list-item-content>
                      </template>
                      <template v-slot:no-data>
                        <v-list-item v-if="customerSearchInput && customerSearchInput.length > 1">
                          <v-list-item-content>
                            <v-list-item-title class="text-center">
                              Không tìm thấy khách hàng: "{{ customerSearchInput }}"
                            </v-list-item-title>
                            <div class="text-center mt-2">
                              <v-btn 
                                color="primary" 
                                small 
                                @click="showCreateCustomerDialog"
                              >
                                <v-icon left small>mdi-plus</v-icon>
                                Tạo mới khách hàng
                              </v-btn>
                            </div>
                          </v-list-item-content>
                        </v-list-item>
                        <v-list-item v-else>
                          <v-list-item-content>
                            <v-list-item-title class="text-center text--disabled">
                              Nhập tên để tìm kiếm khách hàng
                            </v-list-item-title>
                          </v-list-item-content>
                        </v-list-item>
                      </template>
                    </v-autocomplete>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="12" md="6">
                      <v-text-field
                      v-model="currentItem.ProductNameVN"
                      label="Tên hàng tiếng Việt"
                      outlined
                      dense
                      class="input-group--focused"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" md="6">
                    <v-text-field
                      v-model="currentItem.HsCode"
                      label="HSCODE"
                      outlined
                      dense
                      class="input-group--focused"
                    ></v-text-field>
                  </v-col>
                </v-row>
                <v-row>
                  <!-- <v-col cols="12" md="6">
                    <v-text-field
                      v-model="currentItem.PackType"
                      label="Quy cách đóng gói"
                      outlined
                      dense
                      class="input-group--focused"
                    ></v-text-field>
                  </v-col> -->
                  <v-col cols="12" md="6">
                    <h-currency-input
                      v-model="currentItem.ProductNumber"
                      label="Số lượng sản phẩm"
                      :decimal="2"
                      class="input-group--focused"
                      @input="calculateAmounts"
                    ></h-currency-input>
                  </v-col>
                  <v-col cols="12" md="6">
                    <h-currency-input
                      v-model="currentItem.NumberOfPack"
                      label="Tổng số kiện"
                      :decimal="0"
                      class="input-group--focused"
                    ></h-currency-input>
                  </v-col>
                </v-row>
                
                <!-- Cân nặng -->
                <v-row>
                  <v-col cols="12" md="6">
                    <h-currency-input
                      v-model="currentItem.Weight"
                      label="Tổng cân nặng (kg)"
                      :decimal="1"
                      class="input-group--focused"
                      @input="calculateAmounts"
                    ></h-currency-input>
                  </v-col>
                  <v-col cols="12" md="6">
                    <h-currency-input
                      v-model="currentItem.Volume"
                      label="Tổng thể tích (m3)"
                      :decimal="3"
                      class="input-group--focused"
                      @input="calculateAmounts"
                    ></h-currency-input>
                  </v-col>
                </v-row>
                <!-- Thông tin khác -->
                <v-row>
                  <v-col cols="12" md="12">
                    <v-textarea
                      v-model="currentItem.Description"
                      label="Mô tả sản phẩm"
                      outlined
                      dense
                      class="input-group--focused"
                      rows="6"
                    ></v-textarea>
                  </v-col>
                  <!-- <v-col cols="12" md="6">
                    <v-text-field
                      v-model="currentItem.ProductSize"
                      label="Kích thước sản phẩm (D x R x C)"
                      outlined
                      dense
                      class="input-group--focused"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" md="6">
                    <v-text-field
                      v-model="currentItem.BrandName"
                      label="Nhãn hiệu"
                      outlined
                      dense
                      class="input-group--focused"
                    ></v-text-field>
                  </v-col> -->
                </v-row>
                <!-- Công suất / dung tích sản phẩm -->
                <!-- <v-row>
                  <v-col cols="12" md="6">
                    <v-text-field
                      v-model="currentItem.ProductCapacity"
                      label="Công suất / Dung tích"
                      outlined
                      dense
                      class="input-group--focused"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" md="6">
                    <v-text-field
                      v-model="currentItem.ProductMaterial"
                      label="Chất liệu"
                      outlined
                      dense
                      class="input-group--focused"
                    ></v-text-field>
                  </v-col>
                </v-row> -->
                <!-- Thông tin sản phẩm -->
                <v-row>
                  <v-col cols="12" md="6">
                    <!-- <v-text-field
                      v-model="currentItem.ProductName"
                      label="Tên hàng"
                      outlined
                      dense
                      class="input-group--focused"
                    ></v-text-field> -->
                    <v-text-field
                        v-model="currentItem.InvoicePrice"
                        label="Giá xuất HĐ"
                        type="number"
                        single-line
                        outlined
                        dense
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" md="6">
                    <v-text-field
                      v-model="currentItem.ProductUses"
                      label="Công dụng"
                      outlined
                      dense
                      class="input-group--focused"
                    ></v-text-field>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="12" md="6">
                    <v-text-field
                      v-model="currentItem.CustomsUnit"
                      label="Đơn vị sản phẩm"
                      class="input-group--focused"
                      outlined
                      dense
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" md="6">
                    <h-currency-input
                      v-model="currentItem.CustomsPriceVND"
                      label="Giá cần khai báo (VND)"
                      :decimal="0"
                      class="input-group--focused"
                      @input="calculateAmounts"
                    ></h-currency-input>
                  </v-col>
                </v-row>
                
                <!-- <v-row>
                  <v-col cols="12">
                    <h-currency-input
                      v-model="currentItem.CustomsAmountVND"
                      label="Tổng tiền cần khai báo (VND)"
                      :decimal="0"
                      class="input-group--focused"
                      readonly
                    ></h-currency-input>
                  </v-col>
                </v-row> -->
                
                <v-row>
                  <v-col cols="12" md="4">
                    <h-currency-input
                      v-model="currentItem.ImportTax"
                      label="Thuế nhập khẩu (%)"
                      :decimal="2"
                      class="input-group--focused"
                      @input="calculateAmounts"
                    ></h-currency-input>
                  </v-col>
                  <v-col cols="12" md="4">
                    <h-currency-input
                      v-model="currentItem.VatTax"
                      label="Thuế VAT (%)"
                      :decimal="2"
                      class="input-group--focused"
                      @input="calculateAmounts"
                    ></h-currency-input>
                  </v-col>
                  <v-col cols="12" md="4">
                    <h-currency-input
                      v-model="currentItem.ServiceFee"
                      label="Phí dịch vụ (%)"
                      :decimal="2"
                      class="input-group--focused"
                      @input="calculateAmounts"
                    ></h-currency-input>
                  </v-col>
                </v-row>
                <!-- <v-row>
                  <v-col cols="12" md="6">
                    <h-currency-input
                      v-model="currentItem.OtherFeeAmount"
                      label="Chi phí ngoài(đ)"
                      :decimal="0"
                      class="input-group--focused"
                      @input="calculateAmounts"
                    ></h-currency-input>
                  </v-col>
                  <v-col cols="12" md="6">
                    <v-text-field
                      v-model="currentItem.OtherFeeNote"
                      label="Ghi chú chi phí ngoài"
                      class="input-group--focused"
                      outlined
                      dense
                    ></v-text-field>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="12">
                    <h-currency-input
                      v-model="currentItem.TotalFeeAmount"
                      label="Tổng phí dịch vụ"
                      :decimal="0"
                      class="input-group--focused"
                      readonly
                    ></h-currency-input>
                  </v-col>
                </v-row>
                
                <v-row>
                  <v-col cols="12" md="6">
                    <h-currency-input
                      v-model="currentItem.EstimateTransitPrice"
                      label="Tiền vận chuyển TQ-VN dự kiến"
                      :decimal="0"
                      class="input-group--focused"
                      @input="calculateAmounts"
                    ></h-currency-input>
                  </v-col>
                  <v-col cols="12" md="6">
                    <h-currency-input
                      v-model="currentItem.EstimateTransitAmount"
                      label="Tổng tiền vận chuyển TQ-VN dự kiến"
                      :decimal="0"
                      class="input-group--focused"
                      @input="calculateAmounts"
                    ></h-currency-input>
                  </v-col>
                </v-row>
                
                <v-row>
                  <v-col cols="12">
                    <h-currency-input
                      v-model="currentItem.TotalAmount"
                      label="Tổng tiền đơn hàng"
                      :decimal="0"
                      class="input-group--focused"
                      readonly
                    ></h-currency-input>
                  </v-col>
                </v-row> -->
                
                <v-row>
                  <v-col cols="12">
                    <v-checkbox
                      v-model="currentItem.IsQuoted"
                      label="Đơn hàng đã khai báo"
                    ></v-checkbox>
                  </v-col>
                </v-row>
              </v-card-text>
            </v-card>
          </v-flex>
          <!-- Cột 2: Thông tin đơn hàng -->
          <v-flex xs12 md6>
            <v-card outlined>
              <v-card-title>
                <v-icon left>mdi-package-variant</v-icon>
                Hình ảnh hàng và thông tin bổ sung
              </v-card-title>
              <v-card-text>
                <!-- Ảnh sản phẩm -->
                <v-row>
                  <v-col cols="12">
                    <label class="text-subtitle-1 mb-2 d-block">Hình ảnh hàng (để khai báo hải quan - tối đa 3 ảnh)</label>
                    <v-card outlined class="pa-3">
                      <v-alert
                        dense
                        text
                        type="info"
                        class="mb-3"
                        icon="mdi-information"
                      >
                        <small>Click vào khung ảnh và nhấn <strong>Ctrl+V</strong> (hoặc <strong>Cmd+V</strong>) để dán ảnh từ clipboard</small>
                      </v-alert>
                      <v-row>
                        <!-- Hình ảnh 1 -->
                        <v-col cols="12" md="4">
                          <div 
                            class="image-upload-container paste-zone"
                            tabindex="0"
                            @paste="handlePasteImage($event, 0)"
                            @click="$event.currentTarget.focus()"
                            :class="{ 'paste-zone-disabled': uploadingImageIndex !== null }"
                          >
                            <v-file-input
                              v-model="imageFiles[0]"
                              accept="image/*"
                              outlined
                              dense
                              hide-details
                              :loading="uploadingImageIndex === 0"
                              :disabled="uploadingImageIndex !== null"
                              @change="uploadImage(0)"
                              prepend-icon="mdi-camera"
                              placeholder="Hình ảnh 1"
                              show-size
                            ></v-file-input>
                            <v-img 
                              v-if="currentItem.ImageUrl" 
                              :src="image_proxy + encodeURIComponent(currentItem.ImageUrl) + '&h=150'" 
                              max-height="150"
                              contain
                              class="mt-2"
                            >
                              <template v-slot:placeholder>
                                <v-row class="fill-height ma-0" align="center" justify="center">
                                  <v-progress-circular indeterminate color="grey lighten-5"></v-progress-circular>
                                </v-row>
                              </template>
                            </v-img>
                            <div class="text-center mt-2" v-if="currentItem.ImageUrl">
                              <v-btn
                                color="error"
                                x-small
                                outlined
                                :disabled="uploadingImageIndex !== null"
                                @click="removeImage(0)"
                              >
                                <v-icon x-small left>mdi-delete</v-icon>
                                Xóa
                              </v-btn>
                            </div>
                          </div>
                        </v-col>

                        <!-- Hình ảnh 2 -->
                        <v-col cols="12" md="4">
                          <div 
                            class="image-upload-container paste-zone"
                            tabindex="0"
                            @paste="handlePasteImage($event, 1)"
                            @click="$event.currentTarget.focus()"
                            :class="{ 'paste-zone-disabled': uploadingImageIndex !== null }"
                          >
                            <v-file-input
                              v-model="imageFiles[1]"
                              accept="image/*"
                              outlined
                              dense
                              hide-details
                              :loading="uploadingImageIndex === 1"
                              :disabled="uploadingImageIndex !== null"
                              @change="uploadImage(1)"
                              prepend-icon="mdi-camera"
                              placeholder="Hình ảnh 2"
                              show-size
                            ></v-file-input>
                            <v-img 
                              v-if="currentItem.ImageUrl2" 
                              :src="image_proxy + encodeURIComponent(currentItem.ImageUrl2) + '&h=150'" 
                              max-height="150"
                              contain
                              class="mt-2"
                            >
                              <template v-slot:placeholder>
                                <v-row class="fill-height ma-0" align="center" justify="center">
                                  <v-progress-circular indeterminate color="grey lighten-5"></v-progress-circular>
                                </v-row>
                              </template>
                            </v-img>
                            <div class="text-center mt-2" v-if="currentItem.ImageUrl2">
                              <v-btn
                                color="error"
                                x-small
                                outlined
                                :disabled="uploadingImageIndex !== null"
                                @click="removeImage(1)"
                              >
                                <v-icon x-small left>mdi-delete</v-icon>
                                Xóa
                              </v-btn>
                            </div>
                          </div>
                        </v-col>

                        <!-- Hình ảnh 3 -->
                        <v-col cols="12" md="4">
                          <div 
                            class="image-upload-container paste-zone"
                            tabindex="0"
                            @paste="handlePasteImage($event, 2)"
                            @click="$event.currentTarget.focus()"
                            :class="{ 'paste-zone-disabled': uploadingImageIndex !== null }"
                          >
                            <v-file-input
                              v-model="imageFiles[2]"
                              accept="image/*"
                              outlined
                              dense
                              hide-details
                              :loading="uploadingImageIndex === 2"
                              :disabled="uploadingImageIndex !== null"
                              @change="uploadImage(2)"
                              prepend-icon="mdi-camera"
                              placeholder="Hình ảnh 3"
                              show-size
                            ></v-file-input>
                            <v-img 
                              v-if="currentItem.ImageUrl3" 
                              :src="image_proxy + encodeURIComponent(currentItem.ImageUrl3) + '&h=150'" 
                              max-height="150"
                              contain
                              class="mt-2"
                            >
                              <template v-slot:placeholder>
                                <v-row class="fill-height ma-0" align="center" justify="center">
                                  <v-progress-circular indeterminate color="grey lighten-5"></v-progress-circular>
                                </v-row>
                              </template>
                            </v-img>
                            <div class="text-center mt-2" v-if="currentItem.ImageUrl3">
                              <v-btn
                                color="error"
                                x-small
                                outlined
                                :disabled="uploadingImageIndex !== null"
                                @click="removeImage(2)"
                              >
                                <v-icon x-small left>mdi-delete</v-icon>
                                Xóa
                              </v-btn>
                            </div>
                          </div>
                        </v-col>
                      </v-row>
                      <v-progress-linear
                        v-if="uploadingImageIndex !== null"
                        indeterminate
                        color="primary"
                        class="mt-3"
                      ></v-progress-linear>
                    </v-card>
                  </v-col>
                </v-row>
                
                <v-row>
                  <v-col cols="12" md="6">
                    <v-text-field
                      v-model="currentItem.Manufacturer"
                      label="Tên nhà cung cấp"
                      outlined
                      dense
                      class="input-group--focused"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" md="6">
                    <v-text-field
                      v-model="currentItem.ManufacturerAddress"
                      label="Địa chỉ nhà cung cấp"
                      outlined
                      dense
                      class="input-group--focused"
                    ></v-text-field>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="12" md="6">
                    <v-text-field v-model="currentItem.LabelCode" label="Mã nhãn (LabelCode)" dense outlined></v-text-field>
                  </v-col>
                  <v-col cols="12" md="6">
                    <v-text-field v-model="currentItem.LabelDate" label="Ngày nhãn (LabelDate)" dense outlined></v-text-field>
                  </v-col>
                </v-row>
                <!-- <v-row>
                  <v-col cols="12" md="4">
                    <h-currency-input
                      v-model="currentItem.ProductNumberInPack"
                      label="Số SP trong mỗi kiện"
                      :decimal="0"
                      class="input-group--focused"
                    ></h-currency-input>
                  </v-col>
                  <v-col cols="12" md="4">
                    <h-currency-input
                      v-model="currentItem.NumberOfPack"
                      label="Số lượng kiện"
                      :decimal="0"
                      class="input-group--focused"
                    ></h-currency-input>
                  </v-col>
                </v-row> -->
                
                <!-- <v-row>
                  <v-col cols="12" md="4">
                    <h-currency-input
                      v-model="currentItem.WeightPrice"
                      label="Giá Kg"
                      :decimal="0"
                      class="input-group--focused"
                      @input="calculateAmounts"
                    ></h-currency-input>
                  </v-col>
                  <v-col cols="12" md="4">
                    <h-currency-input
                      v-model="currentItem.VolumePrice"
                      label="Giá M3"
                      :decimal="0"
                      class="input-group--focused"
                      @input="calculateAmounts"
                    ></h-currency-input>
                  </v-col>
                  <v-col cols="12" md="4">
                    <h-currency-input
                      v-model="currentItem.NumberOfPack"
                      label="Số kiện"
                      :decimal="0"
                      class="input-group--focused"
                      @input="calculateAmounts"
                    ></h-currency-input>
                  </v-col>
                </v-row> -->
                
                
                
                <!-- <v-row>
                  <v-col cols="12" md="6">
                    <mh-date-picker
                      v-model="vnImportDate"
                      plabel="Ngày nhập kho"
                      outlined
                      dense
                      class="input-group--focused px-3"
                    ></mh-date-picker>
                  </v-col>
                  <v-col cols="12" md="6">
                    <mh-date-picker
                      v-model="vnExportDate"
                      plabel="Ngày xuất kho"
                      outlined
                      dense
                      class="input-group--focused px-3"
                    ></mh-date-picker>
                  </v-col>
                </v-row>
                
                <v-row>
                  <v-col cols="12" md="6">
                    <h-currency-input
                      v-model="currentItem.TotalAmount"
                      label="Tổng tiền hàng"
                      :decimal="0"
                      class="input-group--focused"
                      readonly
                    ></h-currency-input>
                  </v-col>
                  <v-col cols="12" md="6">
                    <h-currency-input
                      v-model="currentItem.PaidAmount"
                      label="Đã thanh toán"
                      :decimal="0"
                      class="input-group--focused"
                    ></h-currency-input>
                  </v-col>
                </v-row>
                
                <v-row>
                  <v-col cols="12">
                    <h-currency-input
                      v-model="currentItem.TotalCost"
                      label="Tổng chi"
                      :decimal="0"
                      class="input-group--focused"
                    ></h-currency-input>
                  </v-col>
                </v-row>

                <v-row v-if="currentItem.ID">
                  <v-col cols="12">
                    <v-card outlined>
                      <v-card-title>
                        <v-icon left>mdi-package-variant-closed</v-icon>
                        Danh sách vận đơn
                        <v-spacer></v-spacer>
                        <v-btn
                          color="primary"
                          small
                          @click="addProduct"
                        >
                          <v-icon left>mdi-plus</v-icon>
                          Thêm mới
                        </v-btn>
                      </v-card-title>
                      <v-card-text>
                        <v-data-table
                          :headers="productHeaders"
                          :items="quoteProducts"
                          :loading="productLoading"
                          disable-pagination
                          hide-default-footer
                        >
                          <template slot="item.UserName" slot-scope="{ item }">
                            {{ item.UserName }}
                          </template>
                          <template slot="item.productInfoCN" slot-scope="{ item }">
                            {{ item.productInfoCN }}
                          </template>
                          <template slot="item.Code" slot-scope="{ item }">
                            {{ item.Code }}
                          </template>
                          <template slot="item.SuffixBill" slot-scope="{ item }">
                            {{ item.SuffixBill }}
                          </template>
                          <template slot="item.Deposit" slot-scope="{ item }">
                            {{ formatCurrency(item.Deposit) }}
                          </template>
                          <template slot="item.Weight" slot-scope="{ item }">
                            {{ item.Weight }}
                          </template>
                          <template slot="item.Volume" slot-scope="{ item }">
                            {{ item.Volume }}
                          </template>
                          <template slot="item.NumberOfPack" slot-scope="{ item }">
                            {{ item.NumberOfPack }}
                          </template>
                          <template slot="item.actions" slot-scope="{ item }">
                            <v-btn
                              icon
                              small
                              color="error"
                              @click="removeProduct(item.ID)"
                            >
                              <v-icon>mdi-delete</v-icon>
                            </v-btn>
                          </template>
                        </v-data-table>
                      </v-card-text>
                    </v-card>
                  </v-col>
                </v-row> -->
              </v-card-text>
            </v-card>
          </v-flex>
        </v-layout>
      </v-card>
    </v-container>
    
    <!-- Dialog chọn sản phẩm -->
    <v-dialog v-model="dialogSelectProduct" max-width="1300px">
      <v-card>
        <v-card-title>
          <span class="title">Chọn sản phẩm để thêm vào khai báo</span>
        </v-card-title>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="red darken-1 white--text" @click="dialogSelectProduct = false">
            Đóng
          </v-btn>
          <v-btn color="primary" @click="onSelectProducts">
            Thêm sản phẩm
          </v-btn>
        </v-card-actions>
        <v-card-text>
          <v-container grid-list-md pa-0>
            <v-layout row wrap>
              <v-flex lg12>
                <v-data-table
                  fixed-header
                  height="450px"
                  :headers="availableProductHeaders"
                  :items="availableProducts"
                  item-key="ID"
                  disable-pagination
                  hide-default-footer
                  show-select
                  v-model="selectedProducts"
                >
                  <template slot="item" slot-scope="props">
                    <tr :active="props.isSelected" @click="props.select(!props.isSelected)">
                      <td>
                        <v-checkbox
                          primary
                          hide-details
                          :input-value="props.isSelected"
                        ></v-checkbox>
                      </td>
                      <td>{{ props.item.UserName }}</td>
                      <td>{{ props.item.productInfoCN }}</td>
                      <td>{{ props.item.Code }}</td>
                      <td>{{ props.item.SuffixBill }}</td>
                      <td class="text-right">{{ formatCurrency(props.item.Deposit) }}</td>
                      <td class="text-right">{{ props.item.Weight }}</td>
                      <td class="text-right">{{ props.item.Volume }}</td>
                      <td class="text-right">{{ props.item.NumberOfPack }}</td>
                    </tr>
                  </template>
                </v-data-table>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-text>
      </v-card>
    </v-dialog>
    
    <!-- Dialog tạo mới khách hàng -->
    <v-dialog v-model="dialogCreateCustomer" max-width="600px" persistent>
      <v-card>
        <v-card-title>
          <span class="title">Tạo mới khách hàng</span>
        </v-card-title>
        <v-card-text>
          <v-container>
            <v-form ref="customerForm" v-model="customerFormValid">
              <v-row>
                <v-col cols="12" md="6">
                  <v-text-field
                    v-model="newCustomer.Username"
                    label="Mã khách hàng *"
                    outlined
                    dense
                    :rules="[
                      v => !!v || 'Mã khách hàng không được để trống',
                      v => /^[A-Z0-9]+$/.test(v) || 'Mã khách hàng chỉ được chứa chữ cái viết hoa và số'
                    ]"
                    required
                    hint="Mã khách hàng sẽ được tự động tạo từ tên"
                    persistent-hint
                  ></v-text-field>
                </v-col>
                <v-col cols="12" md="6">
                  <v-text-field
                    v-model="newCustomer.FullName"
                    label="Họ tên *"
                    outlined
                    dense
                    :rules="[v => !!v || 'Họ tên không được để trống']"
                    required
                    @input="generateCustomerCode"
                  ></v-text-field>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12" md="6">
                  <v-text-field
                    v-model="newCustomer.PhoneNumber"
                    label="Số điện thoại *"
                    outlined
                    dense
                    :rules="[
                      v => !!v || 'Số điện thoại không được để trống',
                      v => /^[0-9+\-\s]+$/.test(v) || 'Số điện thoại không hợp lệ'
                    ]"
                    required
                    @input="generateCustomerCode"
                  ></v-text-field>
                </v-col>
                <v-col cols="12" md="6">
                  <v-select
                    v-model="newCustomer.Status"
                    :items="customerStatusOptions"
                    label="Trạng thái"
                    outlined
                    dense
                    item-text="name"
                    item-value="value"
                  ></v-select>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12">
                  <v-text-field
                    v-model="newCustomer.Address"
                    label="Địa chỉ"
                    outlined
                    dense
                  ></v-text-field>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12">
                  <v-alert type="info" outlined dense>
                    <small>
                      <v-icon small left>mdi-information</v-icon>
                      <strong>Lưu ý:</strong> Mật khẩu mặc định <strong>123@456</strong>. Khách hàng sẽ được tự động chọn sau khi tạo thành công.
                    </small>
                  </v-alert>
                </v-col>
              </v-row>
            </v-form>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn 
            color="grey darken-1" 
            text 
            @click="cancelCreateCustomer"
            :disabled="creatingCustomer"
          >
            Hủy
          </v-btn>
          <v-btn 
            color="primary" 
            @click="createCustomer"
            :loading="creatingCustomer"
            :disabled="!customerFormValid"
          >
            Tạo khách hàng
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
// import MHDatePicker from "@/components/daterange/MHDatePicker";
import { mapState } from "vuex";
import configs from "@/configs";
import moment from "moment";
import { print_quote_label } from "@/commons/hpod";
import { sendSuccessNotice, sendErrorNotice, makeid } from "@/commons/utils";
import firebase from 'firebase';
import md5 from "md5";
import _ from "lodash";

export default {
  // components: {
  //   "mh-date-picker": MHDatePicker,
  // },
  data() {
    return {
      vnImportDate: null,
      vnExportDate: null,
      imageFiles: [null, null, null],
      uploadingImageIndex: null, // null means no upload in progress, 0, 1, or 2 indicates which image is being uploaded
      exportingExcel: false,
      productSearchInput: '',
      productSuggestions: [],
      searchLoading: false,
      selectedProductSuggestion: null,
      customerSearchInput: '',
      dialogSelectProduct: false,
      dialogCreateCustomer: false,
      customerFormValid: false,
      creatingCustomer: false,
      selectedProducts: [],
      image_proxy: configs.IMAGE_PROXY,
      productHeaders: [
        { text: "Mã KH", value: "UserName" },
        { text: "Tên hàng TQ", value: "productInfoCN" },
        // { text: "Mã vào kho", value: "Code" },
        { text: "Mã vận đơn", value: "SuffixBill" },
        { text: "Chi kho TQ", value: "Deposit", align: "end" },
        { text: "Cân nặng", value: "Weight", align: "end" },
        { text: "Thể tích", value: "Volume", align: "end" },
        { text: "Số kiện", value: "NumberOfPack", align: "end" },
        { text: "Thao tác", value: "actions", sortable: false, align: "center" }
      ],
      availableProductHeaders: [
        { text: "Mã KH", value: "UserName" },
        { text: "Tên hàng TQ", value: "productInfoCN" },
        // { text: "Mã vào kho", value: "Code" },
        { text: "Mã vận đơn", value: "SuffixBill" },
        { text: "Chi kho TQ", value: "Deposit", align: "end" },
        { text: "Cân nặng", value: "Weight", align: "end" },
        { text: "Thể tích", value: "Volume", align: "end" },
        { text: "Số kiện", value: "NumberOfPack", align: "end" }
      ],
      newCustomer: {
        Username: '',
        FullName: '',
        PhoneNumber: '',
        Address: '',
        Status: 1,
        RoleID: configs.ROLE_TYPE.Customer
      },
      customerStatusOptions: [
        { name: 'Hoạt động', value: 1 },
        { name: 'Tạm khóa', value: 0 }
      ],
      requireRules: [v => !!v || "Trường dữ liệu không được để trống."]
    };
  },
  computed: {
    ...mapState({
      loading: state => state.quote.loading,
      currentItem: state => state.quote.selected,
      customers: state => state.customer.master.data,
      quoteProducts: state => state.product.quoteList.data || [],
      productLoading: state => state.product.loading,
      availableProducts: state => state.product.all.data || [],
    }),
    currentId() {
      return Number(this.$route.params.Pid);
    },
    isExporting() {
      return this.exportingExcel;
    },
    filteredCustomers() {
      if (!this.customerSearchInput || this.customerSearchInput.length < 2) {
        return this.customers;
      }
      
      const searchTerm = this.customerSearchInput.toLowerCase();
      return this.customers.filter(customer => 
        (customer.Username && customer.Username.toLowerCase().includes(searchTerm)) ||
        (customer.FullName && customer.FullName.toLowerCase().includes(searchTerm)) ||
        (customer.PhoneNumber && customer.PhoneNumber.includes(searchTerm))
      );
    }
  }, 
  watch: {
    currentItem() {
      this.vnImportDate = this.currentItem.VnImportDate 
        ? moment(this.currentItem.VnImportDate).format('YYYY-MM-DD')
        : null;
      this.vnExportDate = this.currentItem.VnExportDate 
        ? moment(this.currentItem.VnExportDate).format('YYYY-MM-DD')
        : null;
    },
    productSearchInput(val) {
      if (val && val.length > 1) {
        this.searchProductSuggestions(val);
      } else {
        this.productSuggestions = [];
      }
    },
    vnImportDate(val) {
      if (val) {
        this.currentItem.VnImportDate = val + 'T00:00:00';
      }
    },
    vnExportDate(val) {
      if (val) {
        this.currentItem.VnExportDate = val + 'T00:00:00';
      }
    },
    quoteProducts: {
      handler() {
        // Tự động tính lại khi danh sách sản phẩm thay đổi
        this.calculateAmounts();
      },
      deep: true
    },
    'currentItem.UID'(newUID) {
      // Cập nhật Username khi chọn khách hàng
      if (newUID) {
        const customer = this.customers.find(c => c.ID === newUID);
        if (customer) {
          this.currentItem.Username = customer.Username;
        }
      } else {
        this.currentItem.Username = '';
      }
    }
  },
  methods: {
    showCreateCustomerDialog() {
      // Close autocomplete menu first
      this.$nextTick(() => {
        // Pre-fill customer code if search input exists
        if (this.customerSearchInput) {
          this.newCustomer.Username = this.customerSearchInput.toUpperCase();
          this.newCustomer.FullName = this.customerSearchInput;
        } else {
          this.resetNewCustomer();
        }
        this.dialogCreateCustomer = true;
      });
    },
    
    resetNewCustomer() {
      this.newCustomer = {
        Username: '',
        FullName: '',
        PhoneNumber: '',
        Address: '',
        Status: 1,
        RoleID: configs.ROLE_TYPE.Customer
      };
    },
    
    cancelCreateCustomer() {
      this.dialogCreateCustomer = false;
      this.resetNewCustomer();
      this.customerSearchInput = '';
    },
    
    async createCustomer() {
      if (!this.$refs.customerForm.validate()) {
        return;
      }
      
      this.creatingCustomer = true;
      
      try {
        // Set default password
        const customerData = {
          ...this.newCustomer,
          Password: md5('123@456')
        };
        
        const response = await this.$store.dispatch("customer/setCustomerDetail", {
          data: customerData,
          id: 0
        });
        
        // Refresh customer list to include new customer
        await this.$store.dispatch("commons/getAllCustomer");
        
        // Wait a bit for the store to update
        await new Promise(resolve => setTimeout(resolve, 500));
        
        // Auto-select the new customer - try multiple strategies
        let newCustomerId = null;
        
        // Strategy 1: Get ID from response
        if (response && response.data && response.data.ID) {
          newCustomerId = response.data.ID;
        } 
        // Strategy 2: Find by username (case insensitive)
        else {
          const newCustomer = this.customers.find(c => 
            c.Username && c.Username.toLowerCase() === this.newCustomer.Username.toLowerCase()
          );
          if (newCustomer) {
            newCustomerId = newCustomer.ID;
          }
        }
        
        // Strategy 3: Find by phone number as fallback
        if (!newCustomerId && this.newCustomer.PhoneNumber) {
          const newCustomer = this.customers.find(c => 
            c.PhoneNumber === this.newCustomer.PhoneNumber
          );
          if (newCustomer) {
            newCustomerId = newCustomer.ID;
          }
        }
        
        // Apply the selection
        if (newCustomerId) {
          this.currentItem.UID = newCustomerId;
          console.log('Auto-selected customer ID:', newCustomerId);
        }
        
        sendSuccessNotice(`Đã tạo khách hàng "${this.newCustomer.FullName}" thành công và đã chọn tự động!`);
        this.dialogCreateCustomer = false;
        this.resetNewCustomer();
        this.customerSearchInput = '';
        
      } catch (error) {
        console.error('Error creating customer:', error);
        sendErrorNotice('Có lỗi xảy ra khi tạo khách hàng. Vui lòng thử lại.');
      } finally {
        this.creatingCustomer = false;
      }
    },
    
    generateCustomerCode() {
      if (this.newCustomer.FullName && !this.customerSearchInput) {
        // Generate code from full name (acronym + phone last 4 digits)
        const acronym = this.newCustomer.FullName
          .split(/\s/)
          .reduce((response, word) => response += word.slice(0, 1), '');
        
        let phone = this.newCustomer.PhoneNumber || '';
        phone = phone ? phone.substring(phone.length - 4) : '';
        
        const code = (acronym + phone)
          .normalize('NFD')
          .replace(/[\u0300-\u036f]/g, '')
          .replace(/đ/g, 'd')
          .replace(/Đ/g, 'D')
          .toUpperCase();
          
        this.newCustomer.Username = code;
      }
    },
    
    getDetail() {
      if (!this.currentId) {
        this.$store.commit("quote/setDetail", { 
          ID: 0,
          UID: '',
          Username: '',
          ProductInfo: '',
          ImageUrl: '',
          CustomsPriceCNY: 0,
          CustomsAmountCNY: 0,
          CustomsPriceVND: 0,
          CustomsAmountVND: 0,
          ExchangeRate: 23000,
          WeightPrice: 0,
          VolumePrice: 0,
          NumberOfPack: 0,
          Weight: 0,
          Volume: 0,
          TotalAmount: 0,
          PaidAmount: 0,
          ImportTax: 0,
          VatTax: 8,
          ServiceFee: 0,
          TotalFeeAmount: 0,
          EstimateTransitPrice: 0,
          EstimateTransitAmount: 0,
          IsQuoted: false,
          Status: 0
        });
      } else {
        this.$store.dispatch("quote/getDetail", this.currentId);
        // Load danh sách sản phẩm của khai báo
        this.$store.dispatch("product/getQuoteList", this.currentId);
      }
      this.getCustomerList();
    },
    searchProductSuggestions: _.debounce(function(productInfo) {
      if (!productInfo || productInfo.length < 2) {
        this.productSuggestions = [];
        this.searchLoading = false;
        return;
      }
      
      this.searchLoading = true;
      this.$http.get(`${configs.API}/api/quotes/suggestions/?product_info=${productInfo}`, {
        headers: { Authorization: `Bearer ${this.$store.state.authentication.token}` }
      }).then(response => {
        console.log('API response:', response.data); // Debug log
        if (response.data.message === 'Success') {
          this.productSuggestions = response.data.data.map(item => ({
            text: item.ProductInfo,
            value: item.ProductInfo,
            customsPrice: item.CustomsPriceNote,
            importTax: item.ImportTax,
            vatTax: item.VatTax,
            serviceFee: item.ServiceFee
          }));
          console.log('Processed suggestions:', this.productSuggestions); // Debug log
        }
        this.searchLoading = false;
      }).catch(error => {
        console.warn('Error fetching product suggestions:', error);
        this.productSuggestions = [];
        this.searchLoading = false;
      });
    }, 300),
    onSuggestionSelected(selectedSuggestion) {
      // Xử lý khi chọn suggestion từ combobox tìm kiếm
      if (selectedSuggestion && typeof selectedSuggestion === 'object' && selectedSuggestion.value) {
        this.selectedProductSuggestion = selectedSuggestion;
      } else if (selectedSuggestion && typeof selectedSuggestion === 'string') {
        const suggestion = this.productSuggestions.find(item => item.value === selectedSuggestion);
        if (suggestion) {
          this.selectedProductSuggestion = suggestion;
        }
      }
    },
    applySelectedSuggestionToProductInfo() {
      // Áp dụng suggestion đã chọn vào ProductInfo
      if (this.selectedProductSuggestion) {
        const suggestionText = typeof this.selectedProductSuggestion === 'object' 
          ? this.selectedProductSuggestion.text 
          : this.selectedProductSuggestion;
        this.currentItem.ProductInfo = suggestionText;
        this.selectedProductSuggestion = null;
        this.productSearchInput = '';
      }
    },
    applySelectedSuggestion(currentItem) {
      // Legacy method - kept for compatibility
      if (this.selectedProductSuggestion) {
        // Nếu đã có text, nối thêm
        if (currentItem.ProductInfo && currentItem.ProductInfo.trim()) {
          currentItem.ProductInfo = currentItem.ProductInfo + ' ' + this.selectedProductSuggestion.text;
          sendSuccessNotice('Đã nối thêm gợi ý vào tên hàng hiện tại!');
        } else {
          // Nếu chưa có text, áp dụng trực tiếp
          currentItem.ProductInfo = this.selectedProductSuggestion.text;
          sendSuccessNotice('Đã áp dụng gợi ý thành công!');
        }
        
        // Áp dụng các thông tin khác từ suggestion
        this.applyProductSuggestion(this.selectedProductSuggestion);
        this.clearSuggestionSelection();
      }
    },
    clearSuggestionSelection() {
      // Clear selection và search input
      this.selectedProductSuggestion = null;
      this.productSearchInput = '';
    },
    applyProductSuggestion(suggestion) {
      // Áp dụng thông tin từ suggestion vào form
      if (suggestion) {
        this.currentItem.CustomsPriceNote = suggestion.customsPrice || 0;
        this.currentItem.ImportTax = suggestion.importTax || 0;
        this.currentItem.VatTax = suggestion.vatTax || 8;
        this.currentItem.ServiceFee = suggestion.serviceFee || 0;
        this.calculateAmounts();
      }
    },
    handlePasteImage(event, index) {
      // Prevent if already uploading
      if (this.uploadingImageIndex !== null) {
        event.preventDefault();
        sendErrorNotice('Vui lòng chờ upload ảnh hiện tại hoàn tất');
        return;
      }

      const items = (event.clipboardData || event.originalEvent.clipboardData).items;
      
      for (let i = 0; i < items.length; i++) {
        if (items[i].type.indexOf('image') !== -1) {
          event.preventDefault();
          
          const blob = items[i].getAsFile();
          
          // Convert blob to File object with proper name
          const timestamp = Date.now();
          const extension = blob.type.split('/')[1] || 'png';
          const file = new File([blob], `pasted-image-${timestamp}.${extension}`, {
            type: blob.type,
            lastModified: timestamp
          });
          
          // Set file to imageFiles array
          this.imageFiles[index] = file;
          
          // Trigger upload
          this.$nextTick(() => {
            this.uploadImage(index);
          });
          
          break;
        }
      }
    },
    async uploadImage(index) {
      const imageFile = this.imageFiles[index];
      if (!imageFile) {
        return;
      }

      // Validate file using fileUploadService
      const fileUploadService = require('@/services/fileUploadService').default;
      const validation = fileUploadService.validateFile(imageFile, ['jpg', 'jpeg', 'png', 'gif', 'webp'], 5);
      if (!validation.valid) {
        sendErrorNotice(validation.message);
        this.imageFiles[index] = null;
        return;
      }

      try {
        this.uploadingImageIndex = index;
        // Upload using fileUploadService
        const result = await fileUploadService.uploadSingleFile(imageFile, 'quote');
        if (result.success && result.data && result.data.url) {
          const downloadURL = result.data.url;
          // Update correct image URL based on index
          if (index === 0) {
            this.currentItem.ImageUrl = downloadURL;
          } else if (index === 1) {
            this.currentItem.ImageUrl2 = downloadURL;
          } else if (index === 2) {
            this.currentItem.ImageUrl3 = downloadURL;
          }

          // If quote already exists, update it in the database
          if (this.currentId) {
            const updateData = {};
            if (index === 0) updateData.ImageUrl = downloadURL;
            if (index === 1) updateData.ImageUrl2 = downloadURL;
            if (index === 2) updateData.ImageUrl3 = downloadURL;

            await this.$store.dispatch("quote/setQuoteDetail", {
              data: updateData,
              id: this.currentId
            });
          }

          sendSuccessNotice('Upload ảnh thành công!');
          this.imageFiles[index] = null;
        } else {
          sendErrorNotice(result.message || 'Lỗi upload ảnh!');
        }
      } catch (error) {
        console.error('Upload error:', error);
        sendErrorNotice('Lỗi upload ảnh!');
      } finally {
        this.uploadingImageIndex = null;
      }
    },
    removeImage(index) {
      if (confirm('Bạn có chắc chắn muốn xóa ảnh này?')) {
        // Get current image URL based on index
        let imageUrl = null;
        if (index === 0) {
          imageUrl = this.currentItem.ImageUrl;
          this.currentItem.ImageUrl = '';
        } else if (index === 1) {
          imageUrl = this.currentItem.ImageUrl2;
          this.currentItem.ImageUrl2 = '';
        } else if (index === 2) {
          imageUrl = this.currentItem.ImageUrl3;
          this.currentItem.ImageUrl3 = '';
        }
        
        // If quote exists, update the database
        if (this.currentId) {
          const updateData = {};
          if (index === 0) updateData.ImageUrl = '';
          if (index === 1) updateData.ImageUrl2 = '';
          if (index === 2) updateData.ImageUrl3 = '';
          
          this.$store.dispatch("quote/setQuoteDetail", {
            data: updateData,
            id: this.currentId
          }).catch(error => {
            console.error('Error updating quote:', error);
            sendErrorNotice('Lỗi khi cập nhật thông tin khai báo');
          });
        }
        
        // Optionally delete from Firebase Storage
        if (imageUrl && imageUrl.includes('firebase')) {
          try {
            firebase.storage().refFromURL(imageUrl).delete()
              .then(() => {
                console.log('Image deleted from Firebase Storage');
              })
              .catch((error) => {
                console.warn('Error deleting image from Firebase:', error);
              });
          } catch (error) {
            console.warn('Error deleting image:', error);
          }
        }
        
        sendSuccessNotice('Đã xóa ảnh');
      }
    },
    calculateAmounts() {
      try {
        // Tính toán các giá trị
        this.currentItem.CustomsAmountVND = this.currentItem.CustomsPriceVND * this.currentItem.ProductNumber;

        const importTax =  parseFloat(this.currentItem.ImportTax || 0);
        const vatTax = parseFloat(this.currentItem.VatTax || 0);
        const serviceFee = parseFloat(this.currentItem.ServiceFee || 0);

        // Tính phí dịch vụ
        this.currentItem.TotalFeeAmount = this.currentItem.CustomsAmountVND *(importTax + (1 + importTax/100) * vatTax + serviceFee) / 100 + this.currentItem.OtherFeeAmount;
        
        // Tính tổng tiền đơn hàng
        this.currentItem.TotalAmount = this.currentItem.TotalFeeAmount + this.currentItem.EstimateTransitAmount;
        
      } catch (error) {
        // Handle calculation error silently
        console.warn('Error calculating amounts:', error);
      }
    },
    async saveData() {
      const customer = _.find(this.customers, {'ID': this.currentItem.UID});
      if (customer) {
        this.currentItem.Username = customer.Username;
      }
      await this.$store.dispatch("quote/setDetail", {data: this.currentItem, id: this.currentItem.ID}).then((p) => {
        if(!this.currentItem.ID) {
          this.$router.push({
            name: "QuoteDetail",
            params: { Pid: p.data.ID, title: `Chi tiết khai báo` },
          });
          this.getDetail();
        }
        sendSuccessNotice("Lưu khai báo thành công!");
        // if (this.currentId === 0) {
        //   this.$router.push('/quotes');
        // }
      }).catch(error => {
        sendErrorNotice("Lỗi khi lưu khai báo!");
        console.warn('Error saving quote:', error);
      });
    },
    exportData() {
      if (!this.currentItem.ID) {
        sendErrorNotice("Vui lòng lưu khai báo trước khi xuất file!");
        return;
      }
      
      this.exportingExcel = true;
      this.$store.dispatch("quote/exportDetail", this.currentItem.ID).then(() => {
        this.exportingExcel = false;
        sendSuccessNotice("Xuất file Excel thành công!");
      }).catch(error => {
        this.exportingExcel = false;
        sendErrorNotice("Lỗi khi xuất file Excel!");
        console.warn('Error exporting Excel:', error);
      });
    },
    addProduct() {
      this.dialogSelectProduct = true;
      this.getAvailableProducts();
    },
    getAvailableProducts() {
      // Lấy danh sách sản phẩm có thể thêm vào khai báo (chưa có QuoteID)
      var param = {
        filter: [{
          column: "QuoteID",
          value: 0,
          condition: "equal"
        },
        {
          column: "UID",
          value: this.currentItem.UID,
          condition: "equal"
        }]
      };
      this.$store.dispatch("product/getList", param);
    },
    onSelectProducts() {
      if (this.selectedProducts.length > 0) {
        // Cập nhật QuoteID cho các sản phẩm được chọn
        const productIds = this.selectedProducts.map(p => p.ID);
        this.updateProductsQuote(productIds);
      }
    },
    updateProductsQuote(productIds) {
      // Call API để cập nhật QuoteID cho các sản phẩm
      // Tạm thời dùng cách đơn giản
      const promises = productIds.map(id => {
        return this.$store.dispatch("product/setDetail", {
          data: { QuoteID: this.currentItem.ID },
          id: id
        });
      });
      
      Promise.all(promises).then(() => {
        sendSuccessNotice("Đã thêm sản phẩm vào khai báo!");
        this.dialogSelectProduct = false;
        this.selectedProducts = [];
        // Reload danh sách sản phẩm của khai báo
        this.$store.dispatch("product/getQuoteList", this.currentId).then(() => {
          // Tính toán lại cân nặng và thể tích sau khi reload
          this.calculateAmounts();
        });
      }).catch(error => {
        sendErrorNotice("Lỗi khi thêm sản phẩm!");
        console.warn('Error adding products:', error);
      });
    },
    removeProduct(productId) {
      if (confirm('Bạn có chắc chắn muốn xóa sản phẩm này khỏi khai báo?')) {
        this.$store.dispatch("product/setDetail", {
          data: { QuoteID: 0 },
          id: productId
        }).then(() => {
          sendSuccessNotice("Đã xóa sản phẩm khỏi khai báo!");
          // Reload danh sách sản phẩm của khai báo
          this.$store.dispatch("product/getQuoteList", this.currentId).then(() => {
            // Tính toán lại cân nặng và thể tích sau khi reload
            this.calculateAmounts();
          });
        }).catch(error => {
          sendErrorNotice("Lỗi khi xóa sản phẩm!");
          console.warn('Error removing product:', error);
        });
      }
    },
    formatCurrency(value) {
      if (!value) return '0';
      return new Intl.NumberFormat('vi-VN').format(value);
    },
    formatNumber(value) {
      if (!value) return '0';
      return parseFloat(value).toFixed(3);
    },
    
    // Package management methods
    showAddPackageDialog() {
      this.resetEditingPackage();
      if (!this.currentItem.ID) {
        this.saveData();
      }
      this.dialogPackage = true;
    },
    
    resetEditingPackage() {
      this.editingPackage = {
        ID: 0,
        QuoteID: this.currentItem.ID || 0,
        Length: null,
        Width: null,
        Height: null,
        Weight: null,
        Volume: null,
        Quantity: null
      };
    },
    
    editPackage(packageItem) {
      this.editingPackage = { ...packageItem };
      this.dialogPackage = true;
    },
    
    cancelPackageDialog() {
      this.dialogPackage = false;
      this.resetEditingPackage();
    },
    
    calculatePackageVolume() {
      if (this.editingPackage.Length && this.editingPackage.Width && this.editingPackage.Height) {
        // Convert cm to m³
        const volume = (this.editingPackage.Length * this.editingPackage.Width * this.editingPackage.Height) / 1000000;
        this.editingPackage.Volume = parseFloat(volume.toFixed(3));
      }
    },
    
    async savePackage() {
      if (!this.$refs.packageForm.validate()) {
        return;
      }
      
      this.savingPackage = true;
      try {
        const packageData = { ...this.editingPackage };
        packageData.QuoteID = this.currentItem.ID;
        
        let response;
        if (packageData.ID) {
          // Update existing package
          response = await this.$store.dispatch("quote_packages/setDetail", {
            data: packageData,
            id: packageData.ID
          });
        } else {
          // Create new package
          delete packageData.ID; // Remove ID for new packages
          response = await this.$store.dispatch("quote_packages/setDetail", {
            data: packageData,
            id: 0
          });
        }
        
        sendSuccessNotice(packageData.ID ? "Đã cập nhật kiện hàng!" : "Đã thêm kiện hàng!");
        this.dialogPackage = false;
        this.resetEditingPackage();
        
        // Reload quote detail to get updated packages
        this.getDetail();
        
      } catch (error) {
        sendErrorNotice("Lỗi khi lưu kiện hàng!");
        console.warn('Error saving package:', error);
      } finally {
        this.savingPackage = false;
      }
    },
    
    async deletePackage(packageId) {
      if (!confirm('Bạn có chắc chắn muốn xóa kiện hàng này?')) {
        return;
      }
      
      try {
        await this.$store.dispatch("quote_packages/removeDetail", packageId);
        sendSuccessNotice("Đã xóa kiện hàng!");
        
        // Reload quote detail to get updated packages
        this.getDetail();
        
      } catch (error) {
        sendErrorNotice("Lỗi khi xóa kiện hàng!");
        console.warn('Error deleting package:', error);
      }
    },
    printLabel() {
      print_quote_label(this.currentItem);
    },
    getCustomerList() {
      this.$store.dispatch("customer/getCustomerList", {
          is_master: 1,
          fields: ["ID", "Username", "FullName", "PhoneNumber"]
      });
    },
  },
  mounted() {
    this.getDetail();
    this.$root.$on("REQUEST_REFRESH_DATA", this.getDetail);
    this.$root.$on("REQUEST_CREATE_DATA", this.exportData);
    this.$root.$on("REQUEST_SAVE_DATA", this.saveData);
    this.$root.$on("REQUEST_IMPORT_ACTION", this.printLabel);
  },
  beforeDestroy() {
    this.$root.$off("REQUEST_REFRESH_DATA", this.getDetail);
    this.$root.$off("REQUEST_CREATE_DATA", this.exportData);
    this.$root.$off("REQUEST_SAVE_DATA", this.saveData);
    this.$root.$off("REQUEST_IMPORT_ACTION", this.printLabel);
  },
};
</script>

<style scoped>
.v-card {
  margin-bottom: 20px;
}

.image-upload-container {
  border: 1px solid #e0e0e0;
  border-radius: 4px;
  padding: 10px;
  height: 100%;
  display: flex;
  flex-direction: column;
  position: relative;
  min-height: 250px;
}

.image-upload-container .v-image {
  flex-grow: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 8px auto;
}

/* Paste zone styling */
.paste-zone {
  outline: none;
  transition: all 0.3s ease;
  cursor: pointer;
}

.paste-zone:hover {
  background-color: #f5f5f5;
  border-color: #2196F3 !important;
}

.paste-zone:focus {
  border: 2px solid #2196F3 !important;
  background-color: #e3f2fd;
  box-shadow: 0 0 0 3px rgba(33, 150, 243, 0.1);
}

.paste-zone-disabled {
  opacity: 0.6;
  cursor: not-allowed !important;
  pointer-events: none;
}

.paste-zone:focus::before {
  content: 'Nhấn Ctrl+V (Cmd+V) để dán ảnh';
  position: absolute;
  top: -25px;
  left: 50%;
  transform: translateX(-50%);
  background: #2196F3;
  color: white;
  padding: 4px 12px;
  border-radius: 4px;
  font-size: 12px;
  white-space: nowrap;
  z-index: 10;
  animation: fadeIn 0.3s ease;
}

@keyframes fadeIn {
  from {
    opacity: 0;
    transform: translateX(-50%) translateY(-5px);
  }
  to {
    opacity: 1;
    transform: translateX(-50%) translateY(0);
  }
}
</style>